import { z } from 'zod'

export const EnrollmentSchema = z.object({
  id: z.string().optional(),
  enrollmentDates: z.array(z.any()),
  benefitEffectiveDate: z
    .string({
      required_error: 'Benefit Effective Date is required',
      invalid_type_error: 'Benefit Effective Date is required',
    })
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Benefit Effective Date is required'),
  benefitEffectivePolicy: z.string(),
})
